import { NavLink } from "react-router-dom";
import {
  Home,
  Wrench,
  Bell,
  Wifi,
  X,
  PlayCircle,
  BookOpen,
  CalendarDays,
  Activity,
} from "lucide-react";

function Sidebar({
  sidebarOpen,
  setSidebarOpen,
}) {
  return (
    <aside
      className={`
        fixed lg:static
        top-0 left-0
        h-full
        w-72
        bg-white
        border-r
        border-gray-200
        shadow-sm
        z-50

        transform
        transition-transform
        duration-300

        ${
          sidebarOpen
            ? "translate-x-0"
            : "-translate-x-full"
        }

        lg:translate-x-0
      `}
    >
      {/* HEADER */}
      <div className="px-6 py-6 border-b border-gray-100 flex items-center justify-between">

        <div>
          <img
            src="https://storage.googleapis.com/lsp-webstore/Dashboard/redlogo.jpeg"
            alt="Lightspeed Photonics"
            className="h-14 object-contain"
          />

          <p className="text-sm text-gray-500 mt-2">
            Employee Portal
          </p>
        </div>

        <button
          onClick={() => setSidebarOpen(false)}
          className="lg:hidden"
        >
          <X size={22} />
        </button>

      </div>

      {/* NAVIGATION */}
      <nav className="p-4 space-y-2">

        <NavItem
          to="/dashboard"
          icon={<Home size={18} />}
          label="Home"
          closeMenu={() => setSidebarOpen(false)}
        />

        <NavItem
          to="/dashboard/tools"
          icon={<Wrench size={18} />}
          label="Tools"
          closeMenu={() => setSidebarOpen(false)}
        />

        <NavItem
          to="/dashboard/announcements"
          icon={<Bell size={18} />}
          label="Announcements"
          closeMenu={() => setSidebarOpen(false)}
        />

        <NavItem
          to="/dashboard/wifi"
          icon={<Wifi size={18} />}
          label="WiFi Passwords"
          closeMenu={() => setSidebarOpen(false)}
        />
        <NavItem
          to="/dashboard/cadence-license"
          icon={<Activity size={18} />}
          label="Cadence License"
          closeMenu={() => setSidebarOpen(false)}
        />
        {/*<NavItem
          to="/dashboard/sessions"
          icon={<PlayCircle size={18} />}
          label="Welcome Aboard!"
          closeMenu={() => setSidebarOpen(false)}
        />
        <NavItem
          to="/dashboard/knowledge-hub"
          icon={<BookOpen size={18} />}
          label="Knowledge Hub"
          closeMenu={() => setSidebarOpen(false)}
        />
        <NavItem
          to="/dashboard/attendance"
          icon={<CalendarDays size={18} />}
          label="Attendance"
          closeMenu={() => setSidebarOpen(false)}
        />*/}

      </nav>

      {/* FOOTER */}
      <div className="absolute bottom-0 left-0 right-0 px-6 py-5 border-t border-gray-100">
        <p className="text-xs text-gray-400">
          © Lightspeed Photonics
        </p>
      </div>
    </aside>
  );
}

function NavItem({
  to,
  icon,
  label,
  closeMenu,
}) {
  return (
    <NavLink
      to={to}
      end={to === "/dashboard"}
      onClick={closeMenu}
      className={({ isActive }) =>
        `
        flex
        items-center
        gap-3
        px-4
        py-3.5
        rounded-xl
        transition-all
        duration-200

        ${
          isActive
            ? `
              bg-red-50
              text-[#C00000]
              font-semibold
              border-l-4
              border-[#C00000]
              shadow-sm
            `
            : `
              text-gray-600
              hover:bg-gray-50
              hover:text-[#C00000]
            `
        }
      `
      }
    >
      {icon}
      <span>{label}</span>
    </NavLink>
  );
}

export default Sidebar;